<template>
  <div>
        <!-- ヘッダ -->
    <comVFHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyName"></comVFHeaderAuth>
    <v-main>
      <v-container fluid>
        <!-- 検索条件 -->
        <div class="group-box">
          <span class="box-title">検索条件</span>

          <v-row dense>
            <v-col cols="1" class="d-flex align-center justify-start">
              ユーザID
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="srchCndNo"
                label=""
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="1" class="d-flex align-center justify-start">
              ユーザ名
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="srchCndName"
                label="フリガナまたは漢字を入力してください"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="1" class="d-flex align-center justify-start">
              決裁者
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="srchCndApprover"
                clearable
              ></v-checkbox>
            </v-col>
            <v-col cols="5"> </v-col>
            <v-col cols="2" class="d-flex align-start justify-end">
              <v-btn
                x-large
                color="success"
                dark
                min-width="120px"
                @click="search()"
                >{{ $t("LCM001") }}</v-btn
              >
            </v-col>
          </v-row>
        </div>

        <!-- 検索結果一覧 -->
        <v-data-table
          :headers="headers"
          :items="desserts"
          item-key="no"
          :items-per-page="10"
          loading-text="Loading... Please wait"
          class="v-dtbl-md-1 v-dtbl-head-md-1 v-dtbl-body-md-1 elevation-1"
          :no-data-text="$t('webmsg.common.datatblenodata')"
        >
          <template v-slot:[`item.approver`]="{ item }">
            <v-simple-checkbox v-model="item.approver" disabled></v-simple-checkbox>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-row>
              <template v-if="item.updHiddenFlg">
                <v-col cols="6">
                  <v-btn small color="success" dark min-width="80px" @click="dispModifyView(item.userId)">{{ $t("LCM003") }}</v-btn>
                </v-col>
              </template>
              <template v-else-if="!item.updHiddenFlg">
                <v-col cols="6">
                  <v-btn small color="success" dark min-width="80px" @click="dispModifyView(item.userId)">{{ $t("LCM005") }}</v-btn>
                </v-col>
              </template>

              <template v-if="item.delHiddenFlg">
                <v-col cols="6">
                  <v-btn small color="red" dark min-width="80px" @click="deleteUser(item)">{{ $t("LCM004") }}</v-btn>
                </v-col>
              </template>
            </v-row>
          </template>

        </v-data-table>
      </v-container>
    </v-main>
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
    <comMessageConfirm :msg="dlgMsgConfirmDel.msg" :isOpen="dlgMsgConfirmDel.isOpen" :doYes="dlgMsgConfirmDel.doYes" :doNo="dlgMsgConfirmDel.doNo" />
  </div>
</template>

<script>
import Constants from "../common/constantsVf";
import Utils from "../common/utils";
export default {
  name: "VFVerifyUserListSearch",
  data() {
    return {
      screenTitle: "確認ユーザ一覧検索",
      screenId: "VFU100",
      userName: "",
      companyName: "",
      headers: [
          { text: 'ユーザID', align: 'start', sortable: true, value: 'userNo', width: "15%" },
          { text: 'ユーザ名', align: 'start', sortable: true, value: 'userName', width: "15%" },
          { text: '有効期間', align: 'center', sortable: true, value: 'validityperiodDate', width: "20%" },
          { text: '決裁者', align: 'center', sortable: true, value: 'approver', width: "15%" },
          { text: '編集', align: 'center', sortable: false, value: 'edit', width: "20%" },
      ],
      desserts: [],
      srchCndApprover: "",
      srchCndNo: "",
      srchCndName: "",
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompd.isOpen = false;
          this.search();
        },
      },
      dlgMsgConfirmDel: {
        msg: this.$i18n.t('msg.wrn.cm011'),
        value:"",
        isOpen: false,
        doYes: () => {
          this.suspend(this.dlgMsgConfirmDel.value);
          this.dlgMsgConfirmDel.isOpen = false;
        },
        doNo: () => {
          this.dlgMsgConfirmDel.isOpen = false;
        },
      },
    };
  },
  created() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    // 画面用データストア破棄
    if (to.name != 'VFU210') {
      this.$store.commit("vfVerifyUserListSearch/resetState");
    }
    next();
  },
  methods: {
    /*
     * 初期表示
     */
    initialize() {
      this.setAuthUserInfo();
      // 再検索
      this.reSearch();
    },
    /**
     * 「検索」ボタン押下
     */
    search: async function() {
       // 確認ユーザ一覧検索サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      let apiurl = Constants.URL_API_VFU100P01;
      let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];
      try {
        // 入力データ
        let searchCondition = this.verifyUserInfoListSearchData();
        let data = JSON.stringify(searchCondition);
        // API呼出
        let response = await this.$axios.post(apiurl,data,
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        console.log(response);
        responseData = response.data
        this.displyVerifyUserInfoList(responseData);
        // 画面用データストア(検索条件)登録
        this.$store.dispatch("vfVerifyUserListSearch/setSearchCondition", searchCondition);
      } catch(error) {
          console.log(error);
          apiErrorInfo = error;
      } 
      // 検索完了メッセージ表示
      this.showDialogMsgAfterSearchAPICall(this.dlgMsg, apiErrorInfo, responseData);
    },

    /**
     * 再検索処理
     */
    reSearch: function() {
      // 画面用データストア(検索条件)取得
      let searchCondition = this.$store.getters["vfVerifyUserListSearch/getSearchCondition"];
      if (searchCondition == null || !Object.keys(searchCondition).length) {
        return;
      }
      // 検索条件復元
      this.srchCndName = searchCondition['name'];
      this.srchCndNo = searchCondition['userNo'];
      this.srchCndApprover = searchCondition['approverFlg'];
      // 再検索
      this.search();
    },

   /*
    * 検索用リクエストデータ生成
    */
    verifyUserInfoListSearchData : function() {
      let reqData = {};
      reqData['userNo'] = this.srchCndNo;
      reqData['name'] = this.srchCndName;
      reqData['approverFlg'] = this.srchCndApprover;

      return reqData;
    },

    /*
    * 確認ユーザ情報一覧表示
    */
    displyVerifyUserInfoList : function(responseData) {
      this.desserts = new Array();
      if (responseData.data == null) {
        return;
      }
      
      let searchResultList = responseData.data.verifyUserInfoListSeachResultDtoList;
      if (Utils.isEmptyArry(searchResultList)) {
        return;
      } 
      let request;
      
      for (const value of searchResultList) {
        request = {};
        request['userNo'] = value.userNo;
        request['userName'] = value.name;
        request['userId'] = value.userId;
        request['validityperiodDate'] = value.dispValidityperiodStartDate + ' ～ ' + value.dispValidityperiodEndDate;
        request['approver'] = value.approverFlg;

        request['updateUserId'] = value.updateUserId;
        request['updateDatetime'] = value.updateDatetime;
        request['delHiddenFlg'] = value.delHiddenFlg;
        request['updHiddenFlg'] = value.updHiddenFlg;
        this.desserts.push(request);
      }
    },

    /*
    * 検索完了メッセージ表示
    */
    showDialogMsgAfterSearchAPICall : function(dialog, apiErrorInfo, responseData) {
      
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        dialog.msg = this.$i18n.t('msg.err.cm100', ['確認ユーザ一覧']);
        dialog.isOpen = true;
        return;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          dialog.msg = Utils.createMsgViewStringForErrList(errorList);
          dialog.isOpen = true;
        }else{
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
        }
      }
    },

    /**
     * 「削除」ボタン押下
     */
    deleteUser(suspendItem) {
      this.dlgMsgConfirmDel.value = suspendItem;
      this.dlgMsgConfirmDel.isOpen = true;
    },


    /**
     * 確認ユーザ削除処理
     */
    suspend: async function(suspendItem) {
       // 確認ユーザ削除サービス呼び出し
       let responseData = null;
       let apiErrorInfo = null;
       let apiurl = Constants.getUrlApiVFU100P02(suspendItem.userId);
       let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];
       try {
           // 入力データ
           let data = JSON.stringify(this.verifyUserSuspendData(suspendItem));
           // API呼出
           let response = await this.$axios.put(apiurl,data,
           {
               headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
               responseType: "json",
            });
            console.log(response);
            responseData = response.data
        } catch(error) {
            console.log(error);
            apiErrorInfo = error;
        } 

        // 削除完了メッセージ表示
        this.showDialogMsgAfterSuspendAPICall(apiErrorInfo, responseData);
    },

    /*
    * 削除用リクエストデータ生成
    */
    verifyUserSuspendData : function(suspendItem) {
      let reqData = {};
      reqData['userId'] = suspendItem.userId;
      reqData['userNo'] = suspendItem.userNo;
      reqData['updateDatetime'] = suspendItem.updateDatetime;
      reqData['updateUserId'] = suspendItem.updateUserId;
      return reqData;
    },

    /*
    * 削除完了メッセージ表示
    */
    showDialogMsgAfterSuspendAPICall : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm113', ['ユーザ']);
        this.dlgMsg.isOpen = true;
        return hasError;
      }

      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          return hasError;
        }else{
          this.dlgMsg.msg = responseData.message ;
          this.dlgMsg.isOpen = true;
          return hasError;
        }
      }
    },

    /**
     * 変更画面遷移
     */
    dispModifyView(selectedUserId) {
        this.$router.push(this.$router.resolve({ name: "VFU210", params: {verifyUserId: selectedUserId, srcScreenId: "VFU100" } }).href);
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setVerifyLoginInfoVfMixin();
      this.username = authInfo['username'];
      this.companyName = authInfo['companyname'];
    },
    
  },
}
</script>
<style scoped>
.group-box {
  position: relative;
  margin: 1.3em 0;  padding: 0.3em 2em;
  border: solid 2px #141414;
  border-radius: 8px;
}
.group-box .box-title {
  position: absolute;
  display: inline-block;
  top: -13px;
  left: 10px;
  padding: 0 9px;
  line-height: 1;
  font-size: 18px;
  background: #fff;
  color: #0b0c0c;
  font-weight: bold;
}
.group-box p {
  margin: 0;
  padding: 0;
}
</style>